export const chainConfigs = {
    [1]: {
  "FACTORY_OWNER": "0xDB392f4391462d60B8B4413ef72018Ab595Af9D0",
  "MINT_FEE_RECIPIENT": "0xd1d1D4e36117aB794ec5d4c78cBD3a8904E691D0",
  "PROTOCOL_REWARDS": "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B"
}, [10]: {
  "FACTORY_OWNER": "0x4c7f7b6067fac9a737ecf2ca1a733fc85dd65a2b",
  "MINT_FEE_RECIPIENT": "0x7A810DCd0f8d83B20212326813Db6EF7E9FD030c",
  "PROTOCOL_REWARDS": "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B"
}, [11155111]: {
  "FACTORY_OWNER": "0xCE9F2e8EaFa11637F8A1CB60AE8AaC601Ae30f2D",
  "MINT_FEE_RECIPIENT": "0xCE9F2e8EaFa11637F8A1CB60AE8AaC601Ae30f2D",
  "PROTOCOL_REWARDS": "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B"
}, [420]: {
  "FACTORY_OWNER": "0xbb45052B2260707655Dfd916a416264f5981192c",
  "MINT_FEE_RECIPIENT": "0x5dEe21327CD7CD6725C2578DA1c3E5bb2D2D34b2",
  "PROTOCOL_REWARDS": "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B"
}, [42161]: {
  "FACTORY_OWNER": "0xF7DafC329C93D84267c0E7B146C0bD68807f6A03",
  "MINT_FEE_RECIPIENT": "0x10Fb02A68C3EA8bD439A6f515dcE07CC049f5c94",
  "PROTOCOL_REWARDS": "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B"
}, [421614]: {
  "FACTORY_OWNER": "0x256537b56007b32BabEB44E868EC8AA5cBF03D30",
  "MINT_FEE_RECIPIENT": "0x256537b56007b32BabEB44E868EC8AA5cBF03D30",
  "PROTOCOL_REWARDS": "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B"
}, [5]: {
  "FACTORY_OWNER": "0xDC498668B5e6CC518fD58A2ADBF614Fd3A13D3a0",
  "MINT_FEE_RECIPIENT": "0x9444390c01Dd5b7249E53FAc31290F7dFF53450D",
  "PROTOCOL_REWARDS": "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B"
}, [7777777]: {
  "FACTORY_OWNER": "0xdEA20c96253dc2d64897D2b8d27A8d935dE74955",
  "MINT_FEE_RECIPIENT": "0xEcfc2ee50409E459c554a2b0376F882Ce916D853",
  "PROTOCOL_REWARDS": "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B"
}, [8453]: {
  "FACTORY_OWNER": "0x004d6611884B4A661749B64b2ADc78505c3e1AB3",
  "MINT_FEE_RECIPIENT": "0x7bf90111Ad7C22bec9E9dFf8A01A44713CC1b1B6",
  "PROTOCOL_REWARDS": "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B"
}, [84531]: {
  "FACTORY_OWNER": "0x02539E813cA450C2c7334e885423f4A899a063Fe",
  "MINT_FEE_RECIPIENT": "0x02539E813cA450C2c7334e885423f4A899a063Fe",
  "PROTOCOL_REWARDS": "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B"
}, [999]: {
  "FACTORY_OWNER": "0xE84DBB2B25F761751231a9D0DAfbdD4dC3aa8252",
  "MINT_FEE_RECIPIENT": "0xE84DBB2B25F761751231a9D0DAfbdD4dC3aa8252",
  "PROTOCOL_REWARDS": "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B"
}, [999999999]: {
  "FACTORY_OWNER": "0xdae22ce69Afcb7f4bc37D32E267645722949DE0E",
  "MINT_FEE_RECIPIENT": "0xdae22ce69Afcb7f4bc37D32E267645722949DE0E",
  "PROTOCOL_REWARDS": "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B"
}
  };